import { CommonButtonTypes } from 'Common/Types/Types';
import React, { Fragment } from 'react';
import { useStyles } from './cards.style';
import useMediaQuery from '@material-ui/core/useMediaQuery';
interface TextCardProps extends CommonButtonTypes {
	copy?: string | undefined;
	number?: number | undefined;
	only?: boolean | undefined;
	children?: any;
}
const TextCard = ({ common, copy, number, only, children }: TextCardProps) => {
	const classes = useStyles({ common });
	const matches = useMediaQuery('(max-width:400px)');
	return (
		<Fragment>
			{only ? (
				<div
					className={`${classes.colorChangingDiv} cd-timeline-content d-flex justify-content-center align-items-center m-0`}
				>
					<div className="px-5">{children}</div>
				</div>
			) : (
				<section className="cd-timeline-block">
					<div className="cd-timeline-img cd-movie">
						<h4 className={classes.numbering}>{number}</h4>
					</div>
					<div
						className={`${classes.colorChangingDiv} cd-timeline-content d-flex justify-content-center align-items-center`}
						style={{
							height: matches ? 'auto' : '',
						}}
					>
						<div className="px-5">{copy}</div>
					</div>
				</section>
			)}
		</Fragment>
	);
};

export default TextCard;
